module.exports = __webpack_public_path__ + "static/img/home_bg_en.01ee2792.jpeg";